<div class="overlay">
  <div class="loader" [style.width.px]="size" [style.height.px]="size" [style.borderWidth.px]="size / 5.625"></div>
</div>
